import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
    name: 'roundToK',
    standalone: true,
})
export class RoundToKPipe implements PipeTransform {
  transform(value: number): string {
    if (value < 1000 && value > -1000) {
      return value.toString()
    } else {
      let v:number = value; 
      return Math.round(v / 100) /10  + 'k'
    }
  }
}
